import { useEffect } from "react";
import { useAuth } from "../../context/AuthProvider";
import { initClarity, setClarityUser } from "../../services/clarity";

/**
 * Renders nothing. Loads Microsoft Clarity using the runtime project ID
 * from window.config, and attaches the signed-in Okta user to the
 * Clarity session so recordings/heatmaps can be filtered by user.
 *
 * Clarity tracks page views and SPA navigations automatically, so
 * (unlike <GoogleAnalytics />) there is no per-route side effect here.
 *
 * Must be mounted inside <AuthProvider>.
 */
const MicrosoftClarity = () => {
  const { authState } = useAuth();

  useEffect(() => {
    initClarity();
  }, []);

  useEffect(() => {
    if (authState.isLoading || !authState.isAuthenticated) return;

    const email =
      authState.user?.email || localStorage.getItem("userEmail") || null;
    const name = authState.user?.name || null;
    const userId = authState.user?.sub || null;
    setClarityUser({ userId, email, name });
  }, [authState.isAuthenticated, authState.isLoading, authState.user]);

  return null;
};

export default MicrosoftClarity;
